<template>
  <el-container  class="body_container">
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex">
        <el-col class="body_title">资源管理</el-col>
      </el-row>
    </el-header>
    <el-main class="search_result">
      <el-table
        :data="tableData"
        style="width: 100%;"
        row-key="id"
        highlight-current-row
        border
        default-expand-all
        @current-change="handleCurrentChange"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column
          prop="name"
          label="资源名称"
          min-width="150px">
        </el-table-column>
        <el-table-column
          prop="code"
          label="资源代码"
          min-width="120px">
        </el-table-column>
        <el-table-column
          prop="url"
          label="资源地址"
          min-width="180px">
        </el-table-column>
        <el-table-column prop="category" :formatter="handleCategory" label="类别" min-width="120px">
        </el-table-column>
        <el-table-column prop="id" label="操作" width="116px">
          <template slot-scope="scope">
            <i class="el-icon-plus" @click="addResource(scope.row)" style="font-size: 16px;color: #333;cursor: pointer"></i>
            &nbsp;&nbsp;
            <i class="el-icon-edit" @click="editResource(scope.row)" v-if="scope.row.pid!==0" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;&nbsp;
            <i class="el-icon-delete" @click="delResource(scope.row)" v-if="scope.row.pid!==0" style="font-size: 16px;color: #666;cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog title="资源信息" :visible.sync="resourceDialog">
      <el-form :model="resource">
        <!--<el-form-item label="资源id:" v-if="resourceStatus">-->
          <!--<el-input v-model="resource.id" size="small" type="text" style="width: 320px"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="资源名称:">
          <el-input v-model="resource.name" placeholder="资源名称" size="small" type="text" style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="资源代码:">
          <el-input v-model="resource.code" placeholder="资源代码" size="small" type="text"
                    style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="资源地址:">
          <el-input v-model="resource.url" placeholder="资源地址" size="small" type="text"
                    style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="类别:">
          <el-select v-model="resource.category" placeholder="请选择资源类型" style="width: 240px">
            <el-option label="菜单" value="M"></el-option>
            <el-option label="操作" value="A"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="dialog-footer" style="text-align: right">
          <el-button @click="cancel">{{'取消'}}</el-button>
          <el-button type="primary" @click="save">{{'保存'}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import resource from '@/api/resource'
export default {
  name: 'Resource',
  data () {
    return {
      resourceDialog: false,
      resourceStatus: false,
      resource: {
        id: null,
        name: '',
        code: '',
        url: '',
        pid: null,
        node: '',
        category: ''
      },
      tableData: [],
      searchVo: {
        keyword: ''
      }
    }
  },
  methods: {
    reload(){
      resource.list({keyword: this.searchVo.keyword}).then(res => {
        // console.log(res.data.data)
        this.tableData = res.data.data
      })
    },
    addResource (row) {
      this.resourceDialog = true
      this.resource = {
        id: null,
        name: '',
        code: '',
        url: '',
        pid: row.id,
        node: '',
        category: ''
      }
    },
    editResource (row) {
      this.resourceDialog = true
      this.resource = {
        id: row.id,
        name: row.name,
        code: row.code,
        url: row.url,
        pid: row.pid,
        node: row.node,
        category: row.category
      }
    },
    delResource (row) {
      this.$confirm('此操作将永久删除该资源, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resource.del({id: row.id}).then(res => {
          this.$message({
            type: 'success',
            message: res.data.message
          })
          this.reload()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleCurrentChange(val) {
    },
    cancel () {
      this.resourceDialog = false
    },
    save () {
      console.log(this.resource)
      resource.save(this.resource).then(res => {
        this.$message({
          type: 'success',
          message: res.data.message
        })
        this.reload()
        this.resourceDialog = false
      })
    },
    handleCategory (row) {
      return row.category==='M'? '菜单': row.category === 'A'? '操作': '未知'
    }
  },
  created(){
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/system/Resource.vue